import React from "react";
import styled from "styled-components";
import { LifeAtButtonV2 } from "@common/LifeAtButtonV2/LifeAtButtonV2";
import LifeAtModal from "@common/LifeAtModal/LifeAtModal";
import { LifeAtBodyPrimary, LifeAtBodySecondary } from "@common/LifeAtText/LifeAtText";

const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 15px;
`;

const Image = styled.img`
    width: 300px;
    height: auto;
`;

const TASK_TO_TIMER_IMG_URL =
    "https://firebasestorage.googleapis.com/v0/b/lifeatspaces-prod.appspot.com/o/images%2FtaskToTimer%2Ftask-to-timer.png?alt=media&token=9d42d5bf-1e42-446d-9cec-5308969aa62a";
const MODAL_HEADER = "Start a timer from your task!";
const MODAL_SUBHEADER = "Assign a duration to a task by dragging it to your calendar";
const CONTINUE_BUTTON_LABEL = "Try it";

interface TaskToTimerInfoModalProps {
    isOpen: boolean;
    handleCloseModal: () => void;
}
export default function TaskToTimerInfoModal(props: TaskToTimerInfoModalProps) {
    return (
        <LifeAtModal isOpen={props.isOpen} closeModal={props.handleCloseModal}>
            <ModalContent>
                <LifeAtBodyPrimary>{MODAL_HEADER}</LifeAtBodyPrimary>
                <LifeAtBodySecondary>{MODAL_SUBHEADER}</LifeAtBodySecondary>
                <Image src={TASK_TO_TIMER_IMG_URL} />
                <LifeAtButtonV2 variant={"outline"} onClick={props.handleCloseModal}>
                    {CONTINUE_BUTTON_LABEL}
                </LifeAtButtonV2>
            </ModalContent>
        </LifeAtModal>
    );
}
